(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    

  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"]) return;
  try {
    
  $(window).on("load", function () {
var prodArray=JSON.parse(localStorage.getItem("recentlyViewed"));

for(var i=0; i<prodArray?.length; i++){
var image = prodArray[i].featured_image;
var handle= prodArray[i].handle;
var title= prodArray[i].title;
var vendor= prodArray[i].vendor;
var price= prodArray[i].price;
var sku= prodArray[i].variants[0].sku;
$(".scroller").append(`<li class="fixc slider__slide scroll-trigger animate--slide-in"  style="--animation-order: 1;">
    <link href="//www.bikenbiker.com/cdn/shop/t/128/assets/component-rating.css?v=157771854592137137841688121293" rel="stylesheet" type="text/css" media="all">
    <div class="card-wrapper product-card-wrapper underline-links-hover">
        <div class="
        card
        card--standard
         card--media
      " style="--ratio-percent: 100%;">
            <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 100%;">
                <div class="card__media">
                    <div class="media media--transparent media--hover-effect">

                        <img src="${image}">
                    </div>
                </div><div class="card__content">
                    <div class="card__information">
                        <h3 class="card__heading">
                            <a href="/products/${handle}" class="full-unstyled-link" aria-labelledby="StandardCardNoMediaLink-template--16728204148963__572fd883-e265-4aa9-9c44-ebe74d9da985-8110311145699 NoMediaStandardBadge-template--16728204148963__572fd883-e265-4aa9-9c44-ebe74d9da985-8110311145699">
                                ${title}
                            </a>
                        </h3>
                    </div>
                </div>
            </div>
            <div class="card__content">
                <div class="card__information">
                    <h3 class="card__heading h5" id="title-template--16728204148963__572fd883-e265-4aa9-9c44-ebe74d9da985-8110311145699">
                        <a href="/products/${handle}" id="CardLink-template--16728204148963__572fd883-e265-4aa9-9c44-ebe74d9da985-8110311145699" class="full-unstyled-link" aria-labelledby="CardLink-template--16728204148963__572fd883-e265-4aa9-9c44-ebe74d9da985-8110311145699 Badge-template--16728204148963__572fd883-e265-4aa9-9c44-ebe74d9da985-8110311145699">
                            ${title}
                        </a>
                    </h3>
                    <div class="card-information">
                        <span class="visually-hidden">Vendor:</span>
                        <div class="caption-with-letter-spacing light">${vendor}</div><span class="caption-large light"></span>
                        <div class="
    price ">
                            <div class="price__container">
                                <div class="price__regular">
                                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                    <span class="price-item price-item--regular">
                                        <b>M.R.P.</b> ₹ ${(price/100).toFixed(2)}
                                    </span>
                                </div>
                                <div class="price__sale">
                                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                    <span>
                                        <s class="price-item price-item--regular">



                                        </s>
                                    </span><span class="visually-hidden visually-hidden--inline">Sale price</span>
                                           <span class="price-item price-item--sale price-item--last">
                                               <b>M.R.P.</b> ₹ ${(price/100).toFixed(2)}
                                           </span>
                                </div>
                                <small class="unit-price caption hidden">
                                    <span class="visually-hidden">Unit price</span>
                                    <span class="price-item price-item--last">
                                        <span></span>
                                        <span aria-hidden="true">/</span>
                                        <span class="visually-hidden">&nbsp;per&nbsp;</span>
                                        <span>
                                        </span>
                                    </span>
                                </small>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</li>`);
}})
  const rightBtn = document.querySelector('#right-button');
const leftBtn = document.querySelector('#left-button');

rightBtn.addEventListener("click", function(event) {
  const conent = document.querySelector('#scroller');
  conent.scrollLeft += 260;
  event.preventDefault();
});

leftBtn.addEventListener("click", function(event) {
  const conent = document.querySelector('#scroller');
  conent.scrollLeft -= 260;
  event.preventDefault();
});

  } catch(e) { console.error(e); }
})();
})();
